// If a dictionary value is an array type, add entry to the value at key
export const addToDictArrayValue = <K extends string, E>(dict: Record<K, E[]>, key: K, entry: E) => {
	if (dict[key]) {
		dict[key].push(entry);
	} else {
		dict[key] = [entry];
	}
};